class VanillaTab {
  constructor(rootSelector, triggerSelector, contentSelector) {
    this.root = document.querySelector(rootSelector);
    if (!this.root) return;

    this.triggerSelector = triggerSelector;
    this.contentSelector = contentSelector;

    this.triggers = Array.from(
      this.root.querySelectorAll(this.triggerSelector),
    );
    this.contents = Array.from(
      this.root.querySelectorAll(this.contentSelector),
    );

    if (!this.triggers.length || !this.contents.length) return;

    this.onClick = this.onClick.bind(this);
    this.init();
  }

  init() {
    this.triggers.forEach((trigger, index) => {
      trigger.addEventListener("click", (e) => this.onClick(e, index));
    });

    const activeTriggerIndex = this.triggers.findIndex((trigger) =>
      trigger.classList.contains("--active"),
    );

    const activeIndex = activeTriggerIndex >= 0 ? activeTriggerIndex : 0;
    this.activate(activeIndex);
  }

  onClick(e, index) {
    e.preventDefault();
    this.activate(index);
  }

  activate(index) {
    this.triggers.forEach((trigger) => {
      trigger.classList.remove("--active");
    });

    this.contents.forEach((content) => {
      content.classList.remove("--active");
    });

    if (this.triggers[index]) {
      this.triggers[index].classList.add("--active");
    }

    if (this.contents[index]) {
      this.contents[index].classList.add("--active");
    }
  }
}

export default VanillaTab;
